/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrmarginnone2Inputs */

const en_qrmarginnone2 = /** @type {(inputs: Qrmarginnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const de_qrmarginnone2 = /** @type {(inputs: Qrmarginnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Qrmarginnone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrmarginnone2 = /** @type {((inputs?: Qrmarginnone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrmarginnone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrmarginnone2(inputs)
	return de_qrmarginnone2(inputs)
});
export { qrmarginnone2 as "qrMarginNone" }